import { getShareLinkRegimeUnread } from "routes/schedule/plugins/share-link-comments/share-link-comments.controller"
import { CommentsTabUnreadLabel } from "./comments-tab-unread-label"
import { useShareLinkCommentRegimeId } from "./use-share-link-comment-regime-id"

// Internal (sharer) regime Comments tab label: shows the count of regime threads with recipient
// comments / replies the reviewer has not yet seen or answered. Resolves its own regime from the
// bound tree item (the tab bar shares the regime view's context) and reads its own count, so it
// updates via the ShareLinkComment + read-state invalidation groups without re-running the registrar.
export function ShareRegimeCommentsTabLabel() {
    const regimeId = useShareLinkCommentRegimeId()
    const unread = getShareLinkRegimeUnread.useResults({ regimeId })
    return <CommentsTabUnreadLabel total={unread?.total ?? 0} />
}
